import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';

import { useFeatureFlagJson } from 'src/hooks/feature-flag';

import AppWideBanner, { AppWideBannerAction } from './AppWideBanner';

const LaunchDarklyBanner: FC = () => {
  const { t } = useTranslation();
  const inAppBanner = useFeatureFlagJson('in-app-banner');

  if (!inAppBanner || !inAppBanner.text) {
    return null;
  }

  const { text } = inAppBanner;

  let action: AppWideBannerAction | undefined;
  if (inAppBanner.url) {
    action = {
      label: inAppBanner.urlText || t('hiring-dashboard-nav:nav.banner.learnMore'),
      href: inAppBanner.url,
    };
  }

  return <AppWideBanner text={text} action={action} />;
};

export default LaunchDarklyBanner;
